import { GameObject } from "./GameObject";

export class Sprite extends GameObject {
  public readonly width: number;
  public readonly height: number;
  public readonly source: CanvasImageSource;
  public readonly anchor: { x: number, y: number };
  public opacity: number = 1;
  public scale: number = 1;
  
  constructor({ x, y, width, height, source, anchor }: { x: number, y: number, width: number, height: number, anchor : { x: number, y: number }, source: CanvasImageSource }) {
    super({ x, y })
    this.width = width
    this.height = height
    this.source = source
    this.anchor = anchor
  }

  public render(context: CanvasRenderingContext2D) {
    if (this.hidden) return;

    context.save();
    context.globalAlpha *= this.opacity;
    context.translate(this.x, this.y);
    context.rotate(this.rotation);
    context.scale(this.scale, this.scale);
    context.translate(-this.width * this.anchor.x, -this.height * this.anchor.y);
    context.drawImage(this.source, 0, 0, this.width, this.height);
    context.restore();
  }
} 
